import { CONSORS_NOTES_REQUEST_FAILURE_REASONS, CONSORS_NOTES_REQUEST_STATUSES } from 'cpool-constants';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

// export type ConsorsNotesRequestTableSchema = {
//     loanRequestId: string;
//     status: CONSORS_NOTES_REQUEST_STATUS;
//     errorMessage?: string;
//     failureReason?: CONSORS_NOTES_REQUEST_FAILURE_REASON | null;
// };

export const ConsorsNotesRequestTableDefinitionZod = z.object({
    errorMessage: z.string().nullish(),
    failureReason: z.nativeEnum(CONSORS_NOTES_REQUEST_FAILURE_REASONS).nullish(),
    loanRequestId: schemaId,
    status: z.nativeEnum(CONSORS_NOTES_REQUEST_STATUSES),
    subscriptionIdentifier: z.string().nullish(),
});

export type ConsorsNotesRequestTableSchema = z.infer<typeof ConsorsNotesRequestTableDefinitionZod>;
